import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { HttpEventType, HttpClient } from '@angular/common/http';
import { AppService } from 'src/app/app.service';
import { AbstractControlOptions, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-addresses',
  templateUrl: './addresses.component.html',
  styleUrls: ['./addresses.component.scss']
})
export class AddressesComponent implements OnInit {
  userId: string | any;
  billingForm = new FormGroup({
    invoiceToPhone: new FormControl(''),
    invoiceToCity: new FormControl('', [Validators.required]),
    invoiceToState: new FormControl('', [Validators.required]),
    invoiceToPin: new FormControl('', [Validators.required]),
    invoiceToAddress: new FormControl('', [Validators.required]),
    invoiceToGSTINUIN: new FormControl('', [Validators.required]),
    shipToPhone: new FormControl(''),
    shipToCity: new FormControl(''),
    shipToState: new FormControl(''),
    shipToPin: new FormControl(''),
    shipToAddress: new FormControl(''),
  });

  isAddMode!: boolean;
  submitted = false;
  private sub: any;
  states: any = [];

  constructor(private http: HttpClient, public appService: AppService,
    private route: ActivatedRoute, private router: Router,
    public snackBar: MatSnackBar) { }

  ngOnInit() {
    this.isAddMode = true;
    this.getAddressById();
    this.GetStates();
  }



  onSubmit() {


    this.submitted = true;
    // stop here if form is invalid
    if (this.billingForm.invalid) {
      return;
    }
    if (this.isAddMode) {

      this.onBillingFormSubmit();
    } else {
      this.updateBillingForm();
    }
  }
  private onBillingFormSubmit() {

    var formData = new FormData();
    formData.append('invoiceToPhone', this.billingForm.value.invoiceToPhone);
    formData.append('invoiceToCity', this.billingForm.value.invoiceToCity);
    formData.append('invoiceToState', this.billingForm.value.invoiceToState);
    formData.append('invoiceToPin', this.billingForm.value.invoiceToPin);
    formData.append('invoiceToAddress', this.billingForm.value.invoiceToAddress);
    formData.append('invoiceToGSTINUIN',this.billingForm.value.invoiceToGSTINUIN);
    formData.append('shipToPhone', this.billingForm.value.shipToPhone);
    formData.append('shipToCity', this.billingForm.value.shipToCity);
    formData.append('shipToState', this.billingForm.value.shipToState);
    formData.append('shipToPin', this.billingForm.value.shipToPin);
    formData.append('shipToAddress', this.billingForm.value.shipToAddress);
    console.log(this.billingForm);

    this.appService.addEditbillingShippingAddress('api/User/AddEditBillingShippingAddress', this.billingForm.value).subscribe((response: any) => {
      this.snackBar.open('Saved successfuly!', '×', { panelClass: 'success', verticalPosition: 'top', duration: 3000 });
    }, error => {
      this.snackBar.open('Something went wrong!', '×', { panelClass: 'error', verticalPosition: 'top', duration: 3000 });
    }
    );
  }
  private updateBillingForm() {
    var formData = new FormData();
    formData.append('trainingId', this.userId)
    formData.append('invoiceToPhone', this.billingForm.value.invoiceToPhone);
    formData.append('invoiceToCity', this.billingForm.value.invoiceToCity);
    formData.append('invoiceToState', this.billingForm.value.invoiceToState);
    formData.append('invoiceToPin', this.billingForm.value.invoiceToPin);
    formData.append('invoiceToAddress', this.billingForm.value.invoiceToAddress);
    formData.append('invoiceToGSTINUIN',this.billingForm.value.invoiceToGSTINUIN);
    formData.append('shipToPhone', this.billingForm.value.shipToPhone);
    formData.append('shipToCity', this.billingForm.value.shipToCity);
    formData.append('shipToState', this.billingForm.value.shipToState);
    formData.append('shipToPin', this.billingForm.value.shipToPin);
    formData.append('shipToAddress', this.billingForm.value.shipToAddress);

    this.appService.addEditbillingShippingAddress('api/User/AddEditBillingShippingAddress', formData).subscribe((response: any) => {
      this.snackBar.open('Update successfuly!', '×', { panelClass: 'success', verticalPosition: 'top', duration: 3000 });
    }, error => {
      this.snackBar.open('Something went wrong!', '×', { panelClass: 'error', verticalPosition: 'top', duration: 3000 });
    }
    );
  }
  public getAddressById = () => {
    this.appService.getBillingAddressByUserId("api/User/GetBillingShippingAddressByUserId").subscribe((data: any) => {

      this.billingForm.patchValue(data);
    })
    error => {
      console.log(error.error.errors);
    }
  }

  public GetStates() {
    this.appService.getUserById("api/State").subscribe((data: any) => {
      this.states = data;
    })
    error => {
      console.log(error.error.errors);
    }

  }

  // public onShippingFormSubmit(values:Object):void {
  //   if (this.shippingForm.valid) {
  //     this.snackBar.open('Your shipping address information updated successfully!', '×', { panelClass: 'success', verticalPosition: 'top', duration: 3000 });
  //   }
  // }

  // public onBillingFormSubmit() {
  //   if (this.billingForm.valid) {
  //     this.snackBar.open('Your billing address information updated successfully!', '×', { panelClass: 'success', verticalPosition: 'top', duration: 3000 });
  //   }
  // }
}
